import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 128 128",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(1.87395,0,0,1.87395,-45.8686,-84.3055)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.29966,0,0,1.29966,3.23367,-25.6361)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M18.54,73.243L35.251,56.531L66.707,56.531L49.995,73.243L18.54,73.243Z",
					style: { fill: "rgb(191,191,191)" }
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.29966,0,0,1.29966,3.23367,-25.6361)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M49.995,104.706L66.525,88.176L66.707,56.531L49.995,73.243L49.995,104.706Z",
					style: { fill: "rgb(101,101,101)" }
				})
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 27.329,
				y: 69.555,
				width: 40.881,
				height: 40.891,
				style: { fill: "rgb(39,39,39)" }
			})
		]
	})
});
export default SvgBillet;
